import React from "react";
import { LOGO_LOS_CABOS } from "@/lib/images";

export default function LosCabosLogo({ className = "", inverted = false }) {
  return (
    <img
      src={LOGO_LOS_CABOS}
      alt="Los Cabos"
      className={className}
      style={inverted ? { filter: "brightness(0) invert(1)" } : undefined}
    />
  );
}
